export function hasQuotes(quotes) {
  return Array.isArray(quotes) && quotes.length > 0;
}

export function hardNavigate(url) {
  window.location.assign(url);
}